import React from "react";

import "./uploadLoader.css";
import CheckIcon from "../assets/icons/checkIcon";
import XIcon from "../assets/icons/xIcon";
import AnimatedCheckIcon from "../assets/icons/animatedCheckIcon";

interface UploadLoaderProps {
    success?: boolean;
}

export default function UploadLoader(props: UploadLoaderProps) {
    return <div className={"upload-loader" + (props.success != undefined ? " stop" : "")}>
        {props.success != undefined ? props.success ? <AnimatedCheckIcon/> : <XIcon/> : <></>}
    </div>
}